import { Menu } from 'lucide-react'

interface DashboardMobileHeaderProps {
  onOpenMobile: () => void
}

export function DashboardMobileHeader({ onOpenMobile }: DashboardMobileHeaderProps) {
  return (
    <header className="lg:hidden top-0 z-30 sticky flex items-center gap-4 bg-background px-4 border-b h-16">
      <button type="button" onClick={onOpenMobile} className="lg:hidden">
        <Menu className="w-6 h-6" />
      </button>
      <h1 className="flex items-center gap-2">
        <img src="/pulsify-wordmark.svg" alt="Pulsify" className="h-6 w-auto" />
        <span className="font-medium text-muted-foreground text-sm tracking-wide">Business</span>
      </h1>
    </header>
  )
}
